import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class MapPropsBuilder extends PropsBuilder<'map'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { map: { effect: visualEffect } } });
    return this;
  };
}
